import WSSCImage1 from '../../Images/HR/BODMember/BinaDhakal.jpg'
import WSSCImage2 from '../../Images/HR/OtherSubCommittee/BimalaSubedi.jpeg'
import WSSCImage3 from '../../Images/HR/OtherSubCommittee/KrishnaKumariShrestha.png'
import MESImage1 from '../../Images/HR/BODMember/BishnuKumariRai.jpg'
import MESImage2 from '../../Images/HR/OtherSubCommittee/GyanendraOjha.jpg'
import MESImage3 from '../../Images/HR/OtherSubCommittee/LaxmiPhuyal.jpg'
import ATFImage1 from '../../Images/HR/BODMember/ArjunKumarTimsina.JPG'
import ATFImage2 from '../../Images/HR/BODMember/HiranyaKalakheti.JPG'
import ATFImage3 from '../../Images/HR/OtherSubCommittee/GopalDeuja.JPG'
import ATFImage4 from '../../Images/HR/OtherSubCommittee/HirachandraPokhrel.JPG'
import ATFImage5 from '../../Images/HR/OtherSubCommittee/LaxmiPrasadGautam.jpg'
import LSCmember1 from '../../Images/HR/BODMember/HiranyaKalakheti.JPG'
import LSCmember2 from '../../Images/HR/OtherSubCommittee/PradipLamsal.jpg'
import LSCmember3 from '../../Images/HR/OtherSubCommittee/SanjivDahal.jpeg'
import SSCImage1 from '../../Images/HR/BODMember/BabukrishnaDahal.jpg'
import SSCImage2 from '../../Images/HR/OtherSubCommittee/KrishnaPrasadChapagain.jpeg'
import SSCImage3 from '../../Images/HR/OtherSubCommittee/BindaParajuli.jpg'
import PDCImage1 from '../../Images/HR/BODMember/ArjunKumarTimsina.JPG'
import PDCImage2 from '../../Images/HR/OtherSubCommittee/ChudamaniDulal.jpeg'
import PDCImage3 from '../../Images/HR/OtherSubCommittee/BalikaPoudyal.jpeg'
import CoCSImage1 from '../../Images/HR/OtherSubCommittee/PremprasadBhattarai.jpg'
import CoCSImage2 from '../../Images/HR/OtherSubCommittee/KhagendraprasadAdhikari.jpg'
import CoCSImage3 from '../../Images/HR/OtherSubCommittee/NarayanrasadGhimire.jpeg'
import CoCSImage4 from '../../Images/HR/OtherSubCommittee/GobindaPrasadPhuyal.jpg'
import CoCSImage5 from '../../Images/HR/OtherSubCommittee/MakaranandaParajuli.jpg'
import YMSSImage1 from '../../Images/HR/OtherSubCommittee/SantoshGhimire.jpg'
import YMSSImage2 from '../../Images/HR/OtherSubCommittee/HarkaPahimLimbu.jpg'
import YMSSImage3 from '../../Images/HR/OtherSubCommittee/KalyanDahal.jpeg'
import MFSCImage1 from '../../Images/HR/OtherSubCommittee/SabitraAdhikari.jpeg'
import MFSCImage2 from '../../Images/HR/OtherSubCommittee/BimalaChauhan.jpeg'
import MFSCImage3 from '../../Images/HR/OtherSubCommittee/TankaPrasadDulal.jpg'
import ERMSImage1 from '../../Images/HR/OtherSubCommittee/TeknathPoudel.jpeg'
import ERMSImage2 from '../../Images/HR/OtherSubCommittee/DilliprasadDhakal.jpg'
import ERMSImage3 from '../../Images/HR/OtherSubCommittee/PushpaDhungel.jpg'
import SVSCImage1 from '../../Images/HR/OtherSubCommittee/MadhavprasadSigdel.jpg'
import SVSCImage2 from '../../Images/HR/OtherSubCommittee/Tankanathhandari.jpg'
import SVSCImage3 from '../../Images/HR/OtherSubCommittee/KailashNiraula.jpg'
import MESCImage1 from '../../Images/HR/OtherSubCommittee/RadhikaDhungana.jpeg'
import MESCImage2 from '../../Images/HR/OtherSubCommittee/UrmilaSubedi.jpg'
import MESCImage3 from '../../Images/HR/OtherSubCommittee/SushilPokharel.jpg'

export const CoCSList = [
    {
        id: '1',
        memName: 'प्रेमप्रसाद भट्टराई',
        post: 'संयोजक',
        memImg: CoCSImage1
    },
    {
        id: '2',
        memName: 'खगेन्द्रप्रसाद अधिकारी',
        post: 'सदस्य',
        memImg: CoCSImage2
    },
    {
        id: '3',
        memName: 'नारायणप्रसाद घिमिरे',
        post: 'सदस्य',
        memImg: CoCSImage3
    },
    {
        id: '4',
        memName: 'गोविन्द फुयल',
        post: 'सदस्य',
        memImg: CoCSImage4
    },
    {
        id: '5',
        memName: 'मकरानन्द पराजुली',
        post: 'सदस्य',
        memImg: CoCSImage5
    }
];

export const WSSCList = [
    {
        id: '1',
        memName: 'वीना ढकाल सिटौला',
        post: 'संयोजक',
        memImg: WSSCImage1
    },
    {
        id: '2',
        memName: 'विमला सुवेदी',
        post: 'सदस्य',
        memImg: WSSCImage2
    },
    {
        id: '3',
        memName: 'कृष्णकुमारी श्रेष्ठ',
        post: 'सदस्य',
        memImg: WSSCImage3
    },
];

export const MESList = [
    {
        id: '1',
        memName: 'विष्णुकुमारी राई',
        post: 'संयोजक',
        memImg: MESImage1
    },
    {
        id: '2',
        memName: 'ज्ञानेन्द्र ओझा',
        post: 'सदस्य',
        memImg: MESImage2
    },
    {
        id: '3',
        memName: 'लक्ष्मीप्रसाद फुयल',
        post: 'सदस्य',
        memImg: MESImage3
    },
];

export const YMSSList = [
    {
        id: '1',
        memName: 'सन्तोष घिमिरे',
        post: 'संयोजक',
        memImg: YMSSImage1
    },
    {
        id: '2',
        memName: 'हर्कपाहिम लिम्ब',
        post: 'सदस्य',
        memImg: YMSSImage2
    },
    {
        id: '3',
        memName: 'कल्याण दाहाल',
        post: 'सदस्य',
        memImg: YMSSImage3
    },
];

export const MFSCList = [
    {
        id: '1',
        memName: 'साबित्रा अधिकारी',
        post: 'संयोजक',
        memImg: MFSCImage1
    },
    {
        id: '2',
        memName: 'विमला चौहान',
        post: 'सदस्य',
        memImg: MFSCImage2
    },
    {
        id: '3',
        memName: 'टंकप्रसाद दुलाल',
        post: 'सदस्य',
        memImg: MFSCImage3
    },
];

export const ERMSList = [
    {
        id: '1',
        memName: 'टेकनाथ पौडेल',
        post: 'संयोजक',
        memImg: ERMSImage1
    },
    {
        id: '2',
        memName: 'डिल्लीप्रसाद ढकाल',
        post: 'सदस्य',
        memImg: ERMSImage2
    },
    {
        id: '3',
        memName: 'पुष्पा ढुङ्गेल',
        post: 'सदस्य',
        memImg: ERMSImage3
    },
];

export const SVSCList = [
    {
        id: '1',
        memName: 'माधवप्रसाद सिग्देल',
        post: 'दुलारी सेवाकेन्द्र',
        memImg: SVSCImage1
    },
    {
        id: '2',
        memName: 'टंकनाथ भण्डारी',
        post: 'सुन्दरपुर सेवाकेन्द्र',
        memImg: SVSCImage2
    },
    {
        id: '3',
        memName: 'कैलाश निरौला',
        post: 'विराटचोक सेवाकेन्द्र',
        memImg: SVSCImage3
    },
];

export const MESCList = [
    {
        id: '1',
        memName: 'राधिका ढुङ्गाना',
        post: 'संयोजक',
        memImg: MESCImage1
    },
    {
        id: '2',
        memName: 'उर्मिला सुवेदी',
        post: 'सदस्य',
        memImg: MESCImage2
    },
    {
        id: '3',
        memName: 'सुशिल पोखरेल',
        post: 'सदस्य',
        memImg: MESCImage3
    },
];

export const ATFList = [
    {
        id: '1',
        memName: 'अर्जुनकुमार खत्री तिम्सिना',
        post: 'संयोजक',
        memImg: ATFImage1
    },
    {
        id: '2',
        memName: 'हिरण्य कालाखेती',
        post: 'सदस्य',
        memImg: ATFImage2
    },
    {
        id: '3',
        memName: 'लक्ष्मीप्रसाद गौतम',
        post: 'सदस्य',
        memImg: ATFImage5
    },
    {
        id: '4',
        memName: 'गोपाल देउजा',
        post: 'सदस्य',
        memImg: ATFImage3
    },
    {
        id: '5',
        memName: 'हिराचन्द्र पोखरेल',
        post: 'सदस्य',
        memImg: ATFImage4
    },
];

export const LSComitteeList = [
    {
        id: '1',
        memName: 'हिरण्य कालाखेती',
        post: 'संयोजक',
        memImg: LSCmember1
    },
    {
        id: '2',
        memName: 'प्रदीप लम्साल',
        post: 'सदस्य',
        memImg: LSCmember2
    },
    {
        id: '3',
        memName: 'संजिव दाहाल',
        post: 'सदस्य',
        memImg: LSCmember3
    }
];

export const SSCList = [
    {
        id: '1',
        memName: 'बावुकृष्ण दाहाल',
        post: 'संयोजक',
        memImg: SSCImage1
    },
    {
        id: '2',
        memName: 'कृष्णप्रसाद चापागाई',
        post: 'सदस्य',
        memImg: SSCImage2
    },
    {
        id: '3',
        memName: 'विन्दा पराजुली',
        post: 'सदस्य',
        memImg: SSCImage3
    },
];

export const PDCList = [
    {
        id: '1',
        memName: 'अर्जुनकुमार खत्री तिम्सिना',
        post: 'संयोजक',
        memImg: PDCImage1
    },
    {
        id: '2',
        memName: 'चुडामुणि दुलाल',
        post: 'सदस्य',
        memImg: PDCImage2
    },
    {
        id: '3',
        memName: 'वालिका पौड्याल',
        post: 'सदस्य',
        memImg: PDCImage3
    },
];